import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SearchService } from 'app/features/search/search.service';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { filter } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [
    BreadcrumbModule
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  items: MenuItem[] = [];
  //home?: MenuItem;

  constructor(
    private searchService: SearchService,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }


  ngOnInit(): void {
    const to = sessionStorage.getItem('to') ? JSON.parse(sessionStorage.getItem('to')!) : null;
    const chartId = sessionStorage.getItem('chartId') ? JSON.parse(sessionStorage.getItem('chartId')!) : null;

    this.updateBreadcrumbTrail(to, chartId);

    // this.router.events.pipe(
    //   filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    // ).subscribe((event: NavigationEnd) => {
    //   const to2 = event.urlAfterRedirects.split('/')[1];
    //   this.updateBreadcrumbTrail(to2, chartId);
    // });
  }

  updateBreadcrumbTrail(
    to?: any,
    chartId?: number,
  ) {
    
    //console.log('To: ', to);

    //TABLE VIEW BREADCRUMB
    if (to === 'flight-detail') {
      this.items = [
        {
          //icon: 'pi pi-home', routerLink: '/',
          label: 'Flights', routerLink: '/',
          command: () => { sessionStorage.setItem('to', JSON.stringify('flight-table')) }
        },
        {
          label: 'Leg',
        }
      ];
    }

    else if (to === 'sequence-detail') {
      this.items = [
        {
          label: 'Flights', routerLink: '/',
          command: () => { sessionStorage.setItem('to', JSON.stringify('flight-table')) }
        },
        {
          label: 'Sequence',
        }
      ];
    }

    else if (to === 'sequence-flight-detail') {
      this.items = [
        {
          //icon: 'pi pi-home', routerLink: '/',
          label: 'Flights', routerLink: '/',
          command: () => { sessionStorage.setItem('to', JSON.stringify('flight-table')) }
        },
        {
          label: 'Sequence', routerLink: '/sequence-detail',
          command: () => { sessionStorage.setItem('to', JSON.stringify('sequence-detail')) }
        },
        {
          label: 'Leg',
        }
      ];
    }


    //SEARCH BREADCRUMB

    else if (to === 'search-result') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => {
            sessionStorage.removeItem('to');
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Search', routerLink: '/search',
          command: () => {
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Results', routerLink: this.router.url,
          command: () => { sessionStorage.setItem('to', JSON.stringify('search-result')) }
        }
      ];
    }

    else if (to === 'search-result-seq') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => {
            sessionStorage.removeItem('to')
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Search', routerLink: '/search',
          command: () => {
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Result', routerLink: '/search/result',
          command: () => {
            sessionStorage.setItem('to', JSON.stringify('search-result'));
          }
        },
        {
          label: 'Sequence', routerLink: this.router.url,
          command: () => {
            sessionStorage.setItem('to', JSON.stringify('search-result-seq'));
          }
        },

      ];
    }

    else if (to === 'search-result-seq-leg') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => {
            sessionStorage.removeItem('to');
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Search', routerLink: '/search',
          command: () => {
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Result', routerLink: '/search/result',
          command: () => { sessionStorage.setItem('to', JSON.stringify('search-result')) }
        },
        {
          label: 'Sequence', routerLink: '/sequence-detail',
          command: () => { sessionStorage.setItem('to', JSON.stringify('search-result-seq')) }
        },
        {
          label: 'Leg', routerLink: this.router.url,
          command: () => { sessionStorage.setItem('to', JSON.stringify('search-result-seq-leg')) }
        },

      ];
    }

    else if (to === 'search-result-leg') {

      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => {
            sessionStorage.removeItem('to');
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Search', routerLink: '/search',
          command: () => {
            //sessionStorage.setItem('to', JSON.stringify('search-form'));
            this.clearSearchCache();
            this.searchService.searchResultsPage$.set(0);
          }
        },
        {
          label: 'Results', routerLink: '/search/result',
          command: () => {
            sessionStorage.setItem('to', JSON.stringify('search-result'))
          }
        },
        {
          label: 'Leg', routerLink: this.router.url,
          command: () => {
            sessionStorage.setItem('to', JSON.stringify('search-result-leg'))
          }
        },
      ];
    }

    //CALENDAR BREADCRUMB
    else if (to === 'cal-sequence-detail') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Calendar', routerLink: '/flights/flight-calendar',
          command: () => { sessionStorage.setItem('to', JSON.stringify('flight-calendar')) }
        },
        {
          label: 'Sequence', routerLink: this.router.url
        }
      ];
    }

    else if (to === 'cal-flight-detail') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Calendar', routerLink: '/flights/flight-calendar',
          command: () => { sessionStorage.setItem('to', JSON.stringify('flight-calendar')) }
        },
        {
          label: 'Sequence', routerLink: '/sequence-detail',
          command: () => { sessionStorage.setItem('to', JSON.stringify('cal-sequence-detail')) }
        },
        {
          label: 'Leg', routerLink: this.router.url
        }
      ];
    }

    //ANALYZE - CHARTS BREADCRUMB
    else if (to === 'analyzeChart' && chartId == 0) {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Analyze', routerLink: '/analyze',
          command: () => { sessionStorage.setItem('to', JSON.stringify('analyze')) }
        },
        { label: 'By Year', routerLInk: this.router.url }
      ];
    }

    else if (to === 'analyzeChart' && chartId == 1) {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Analyze', routerLink: '/analyze',
          command: () => { sessionStorage.setItem('to', JSON.stringify('analyze')) }
        },
        { label: 'By Seat', routerLInk: this.router.url }
      ];
    }

    else if (to === 'analyzeChart' && chartId == 2) {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Analyze', routerLink: '/analyze',
          command: () => { sessionStorage.setItem('to', JSON.stringify('analyze')) }
        },
        { label: 'Type', routerLInk: this.router.url }
      ];
    }

    else if (to === 'analyzeChart' && chartId == 3) {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Analyze', routerLink: '/analyze',
          command: () => { sessionStorage.setItem('to', JSON.stringify('analyze')) }
        },
        { label: 'By Month', routerLInk: this.router.url }
      ];
    }

    else if (to === 'analyzeChart-variants') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Analyze', routerLink: '/analyze',
          command: () => { sessionStorage.setItem('to', JSON.stringify('analyze')) }
        },
        {
          label: 'Type', routerLink: '/analyze/pie-chart/',
          command: () => {
            sessionStorage.setItem('to', JSON.stringify('analyzeChart'))
          }
        },
        { label: 'Variants', routerLInk: this.router.url }
      ];
    }

    //About Breadcrumb
    else if (to === 'version') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'About', routerLink: '/about',
          command: () => { sessionStorage.setItem('to', JSON.stringify('about')) }
        },
        {
          label: 'Versions', routerLink: this.router.url,
          command: () => { sessionStorage.setItem('to', JSON.stringify('version')) }
        }
      ];
    }

    else if (to === 'feedback') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'About', routerLink: '/about',
          command: () => { sessionStorage.setItem('to', JSON.stringify('about')) }
        },
        {
          label: 'Feedback', routerLink: this.router.url,
          command: () => { sessionStorage.setItem('to', JSON.stringify('feedback')) }
        }
      ];
    }

    else if (to === 'faq') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'About', routerLink: '/about',
          command: () => { sessionStorage.setItem('to', JSON.stringify('about')) }
        },
        {
          label: 'FAQ', routerLink: this.router.url,
          command: () => { sessionStorage.setItem('to', JSON.stringify('faq')) }
        }
      ];
    }

    else if (to === 'disclaimer') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'About', routerLink: '/about',
          command: () => { sessionStorage.setItem('to', JSON.stringify('about')) }
        },
        {
          label: 'Disclaimer', routerLink: this.router.url,
          command: () => { sessionStorage.setItem('to', JSON.stringify('disclaimer')) }
        }
      ];
    }

    else if (to === 'cache-viewer') {
      this.items = [
        {
          icon: 'pi pi-home', routerLink: '/',
          command: () => { sessionStorage.removeItem('to') }
        },
        {
          label: 'Admin', routerLink: '/admin',
          command: () => { sessionStorage.setItem('to', JSON.stringify('admin')) }
        },
        {
          label: 'Cache', routerLink: this.router.url,
          command: () => { sessionStorage.setItem('to', JSON.stringify('cache-viewer')) }
        }
      ];
    }
  }

  clearSearchCache(): void {
    localStorage.removeItem('crewDetails');
    sessionStorage.removeItem('searchResponse');
    sessionStorage.removeItem('leg');
    sessionStorage.removeItem('sequence');
    sessionStorage.removeItem('nonFilteredSequence');
    sessionStorage.removeItem('nonFilteredResults');
  }


  onBreadcrumbClick(item: any): void {
    this.router.navigate([item.router]);
  }

}
